export const addFacebookPixel = (pixelId) => {
  // Utworzenie funkcji fbq, jeśli jeszcze nie istnieje
  if (!window.fbq) {
    window.fbq = function() {
      if (window.fbq.callMethod) {
        window.fbq.callMethod.apply(window.fbq, arguments);
      } else {
        window.fbq.queue.push(arguments);
      }
    };
    window.fbq.queue = [];
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
  }

  // Utworzenie i dodanie skryptu Facebook Pixel
  let scriptTag = document.createElement('script');
  scriptTag.async = true;
  scriptTag.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(scriptTag);

  // Inicjalizacja Pixela z podanym ID
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');

  // Dodanie obrazka dla użytkowników z wyłączonym JavaScript
  let noscriptTag = document.createElement('noscript');
  let imgTag = document.createElement('img');
  imgTag.height = '1';
  imgTag.width = '1';
  imgTag.style.display = 'none';
  imgTag.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
  noscriptTag.appendChild(imgTag);
  document.body.appendChild(noscriptTag);

  console.log(`Added Facebook Pixel code for ${pixelId}`);
};
